<template>
  <div class="LegalDocsView">
    <div class="LegalDocs">
      <div class="LegalDocs--menu">
        <ul class="list-unstyled">
          <li>
            <RouterLink
              to="/legal/terms-of-use"
            >
              Terms of use
            </RouterLink>
          </li>
          <li>
            <RouterLink
              to="/legal/privacy-policy"
            >
              Privacy Policy
            </RouterLink>
          </li>
          <li>
            <RouterLink
              to="/legal/terms-and-conditions"
            >
              Terms & Conditions
            </RouterLink>
          </li>
        </ul>
      </div>
    </div>
    <RouterView />
  </div>
</template>
<script>

import {
  mapState,
  mapActions,
} from 'vuex';

const LegalModule = 'App/LegalDocs';
export default {
  name: 'LegalDocsView',
  data() {
    return {
      doc: false,
    };
  },
  computed: {
    ...mapState(LegalModule, {
      legalData: STATUS => STATUS.data,
    }),

  },
  async mounted() {
    await this.getLegalDocuments();
  },
  methods: {
    ...mapActions(LegalModule, ['getLegalDocuments']),
  },
};
</script>
